

import React, { useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { BsCheck, BsCheckAll } from "react-icons/bs";
import { io } from "socket.io-client";
import moment from "moment";
import axios from 'axios';
import { deleteMessage as deleteMessageAction } from '../redux/messageSlice';
import { BASE_URL } from '../config';

const socket = io("https://chat.onexgames.in", {
    transports: ['websocket'],
});

const Message = ({ message }) => {
    const scroll = useRef();
    const [showActionMenu, setShowActionMenu] = useState(false);
    const { authUser, selectedUser } = useSelector(store => store.user);
    const dispatch = useDispatch();
    const messageRef = useRef(null);
    let longPressTimer = useRef(null);
    const [copied, setCopied] = useState(false);


    const isAdmin = authUser?.isRole === 1;

    // Handle right click (desktop)
    const handleContextMenu = (e) => {
        e.preventDefault();
        setShowActionMenu(true);
    };

    // Handle long press (mobile)
    const handleTouchStart = (e) => {
        const touch = e.touches[0];
        const initialX = touch.clientX;
        const initialY = touch.clientY;
    
        longPressTimer.current = setTimeout(() => {
            const currentTouch = e.touches[0];
            if (
                Math.abs(currentTouch.clientX - initialX) < 10 && 
                Math.abs(currentTouch.clientY - initialY) < 10
            ) {
                setShowActionMenu(true);
            }
        }, 800);
    };

    // Handle delete actions (admin only)
    const handleDelete = async (deleteType) => {
        try {
            await axios.delete(`${BASE_URL}/api/v1/message/delete/${message._id}`, {
                data: { deleteType },
                withCredentials: true
            });
            dispatch(deleteMessageAction(message._id));
            setShowActionMenu(false);
        } catch (error) {
            console.error("Delete failed:", error);
        }
    };

    // Handle copy message (for everyone)
    const handleCopy = () => {
        if (message?.message) {
            navigator.clipboard.writeText(message.message);
            // setShowActionMenu(false);
              setCopied(true);
        setTimeout(() => {
            setCopied(false);
            setShowActionMenu(false); // Close menu after feedback
        }, 1000);
            
            // Show temporary feedback that message was copied
            // const feedback = document.createElement('div');
            // feedback.textContent = 'Copied to clipboard';
            // feedback.style.position = 'fixed';
            // feedback.style.bottom = '20px';
            // feedback.style.left = '50%';
            // feedback.style.transform = 'translateX(-50%)';
            // feedback.style.backgroundColor = 'rgba(0,0,0,0.7)';
            // feedback.style.color = 'white';
            // feedback.style.padding = '8px 16px';
            // feedback.style.borderRadius = '20px';
            // feedback.style.zIndex = '1000';
            // document.body.appendChild(feedback);
            
            // setTimeout(() => {
            //     document.body.removeChild(feedback);
            // }, 1500);
        }
    };


    // Close menu handlers
    const handleCancel = () => setShowActionMenu(false);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (messageRef.current && !messageRef.current.contains(e.target)) {
                setShowActionMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            clearTimeout(longPressTimer.current);
        };
    }, []);

    useEffect(() => {
        if (scroll.current) {
            scroll.current.scrollIntoView({ behavior: "smooth" });
        }

        if (message?.status === "sent" && message?.receiverId === authUser?._id) {
            socket.emit("messageDelivered", message._id);
        }
    }, [message]);

    // Close menu when clicking outside (updated version)
useEffect(() => {
    const handleClickOutside = (e) => {
        if (showActionMenu && (!messageRef.current?.contains(e.target) || 
            e.target.classList.contains('fixed'))) {
            setShowActionMenu(false);
        }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('touchstart', handleClickOutside);
        clearTimeout(longPressTimer.current);
    };
}, [showActionMenu]);

    const imageUrl = message?.imageUrl;
    const videoUrl = message?.videoUrl;
    const [mediaError, setMediaError] = useState(false);
    const isAdminToAdmin = authUser?.isRole === 1 && 
        message?.senderId !== selectedUser?._id && 
        message?.senderId !== authUser?._id;


            // Render formatted message content
    const renderMessageContent = () => {
        // If there's formatted HTML content, render it directly
        if (message?.formattedMessage) {
            return (
                <div 
                    className="formatted-message"
                    dangerouslySetInnerHTML={{ __html: message.formattedMessage }}
                />
            );
        }
        
        // Otherwise, render plain text
        return message?.message;
    };


    return (
        <div 
            ref={messageRef}
            onContextMenu={handleContextMenu}
            onTouchStart={handleTouchStart}
            onTouchEnd={() => {
                clearTimeout(longPressTimer.current);
            }}
            onTouchCancel={() => {
                clearTimeout(longPressTimer.current);
            }}
            onTouchMove={() => {
                clearTimeout(longPressTimer.current);
            }}
            className="relative"
        >
            <div ref={scroll} className={`chat ${message?.senderId === authUser?._id ? 'chat-end' : 'chat-start'} border-rounded bg-[#efeae2]`}>
                <div className="chat-image avatar">
                    <div className="w-10 rounded-full">
                        {/* Profile image would go here */}
                    </div>
                </div>
                <div className="chat-header">
                    <time className="text-[10px] opacity-50 text-black">
                        {moment(message?.createdAt).format("hh:mm A")}
                    </time>
                </div>

                {imageUrl ? (
                    <div className={`chat-bubble ${isAdminToAdmin ? 'bg-blue-100 text-black' : message?.senderId !== authUser?._id ? 'bg-[#fff]' : 'bg-[#d9fdd3]'} p-0 overflow-hidden`}>
                        <a
                            href={imageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block"
                        >
                            {mediaError ? (
                                <div className="bg-gray-200 p-4 text-center">
                                    Couldn't load image
                                </div>
                            ) : (
                                <img
                                    src={imageUrl}
                                    alt="Chat content"
                                    className="max-w-xs max-h-60 object-contain cursor-pointer"
                                    onError={(e) => {
                                        setMediaError(true);
                                        e.target.onerror = null;
                                    }}
                                />
                            )}
                        </a>
                    </div>
                ) : videoUrl ? (
                    <div className={`chat-bubble ${isAdminToAdmin ? 'bg-blue-100 text-black' : message?.senderId !== authUser?._id ? 'bg-[#fff]' : 'bg-[#d9fdd3]'} p-0 overflow-hidden`}>
                        <a
                            href={videoUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block"
                        >
                            {mediaError ? (
                                <div className="bg-gray-200 p-4 text-center">
                                    Couldn't load video
                                </div>
                            ) : (
                                <video
                                    controls
                                    className="max-w-xs max-h-60 cursor-pointer"
                                    onError={(e) => {
                                        setMediaError(true);
                                        e.target.onerror = null;
                                    }}
                                >
                                    <source src={videoUrl} type="video/mp4" />
                                    Your browser does not support the video tag.
                                </video>
                            )}
                        </a>
                    </div>
                ) : (
                    <div className={`chat-bubble ${isAdminToAdmin ? 'bg-blue-100 text-black' : message?.senderId !== authUser?._id ? 'bg-[#fff] text-black' : 'bg-[#d9fdd3] text-black'}`}
                        style={{
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            maxWidth: '300px'
                        }}
                    >
                       {/* {message?.message} */}
                          {renderMessageContent()}
                    </div>
                )}
                {message?.senderId === authUser?._id && (
                    <div className="text-xs text-gray-400 flex items-center">
                        {message?.status === "sent" && <BsCheck size={18} />}
                        {message?.status === "delivered" && <BsCheckAll size={18} />}
                        {message?.status === "seen" && <BsCheckAll size={18} className="text-blue-500" />}
                    </div>
                )}
                {message.replied && (
                    <div className="text-xs text-green-600 mt-1 flex items-center gap-1">
                        <BsCheckAll size={18} className="text-green-600" />
                        Replied by {message.repliedBy?.username || "Admin"}
                    </div>
                )}
            </div>
            
            {/* WhatsApp-style Action Menu (Copy/Delete) */}
            {showActionMenu && (
                <div className="fixed inset-0 bg-black/30 flex items-end md:items-center justify-center z-50"
                 onClick={(e) => e.target.classList.contains('fixed') && setShowActionMenu(false)}
                >
                    <div className="bg-white rounded-t-xl md:rounded-xl w-full md:max-w-xs shadow-xl">
                        <div className="p-2 space-y-2">
                            {/* COPY OPTION (ALWAYS VISIBLE) */}
                            <button
                                onClick={handleCopy}
                                className="w-full text-left p-3 text-green-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
                            >
                                {/* Copy */}
                                    {copied ? "Copied!" : "Copy"}

                            </button>

                            {/* DELETE OPTION (ONLY FOR ADMINS) */}
                            {isAdmin && (
                                <button
                                    onClick={() => setShowActionMenu('delete')}
                                    className="w-full text-left p-3 text-green-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
                                >
                                    Delete
                                </button>
                            )}

                            <button
                                onClick={handleCancel}
                                className="w-full text-left p-3 text-gray-800 hover:bg-gray-100 rounded-lg text-sm font-medium"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* DELETE CONFIRMATION (ONLY FOR ADMINS) */}
            {showActionMenu === 'delete' && isAdmin && (
                <div className="fixed inset-0 bg-black/30 flex items-end md:items-center justify-center z-50"
                  onClick={(e) => e.target.classList.contains('fixed') && setShowActionMenu(false)}
                >
                    <div className="bg-white rounded-t-xl md:rounded-xl w-full md:max-w-xs shadow-xl">
                        <div className="p-4">
                            <p className="text-gray-800 font-medium mb-4">Delete message?</p>
                            <div className="space-y-3">
                                <button
                                    onClick={() => handleDelete('forEveryone')}
                                    className="w-full text-left p-3 text-red-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
                                >
                                    Delete for everyone
                                </button>
                                <button
                                    onClick={() => handleDelete('forMe')}
                                    className="w-full text-left p-3 text-red-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
                                >
                                    Delete for me
                                </button>
                                <button
                                    onClick={handleCancel}
                                    className="w-full text-left p-3 text-gray-800 hover:bg-gray-100 rounded-lg text-sm font-medium"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Message;



// import React, { useEffect, useRef, useState } from 'react'
// import { useSelector, useDispatch } from "react-redux";
// import { BsCheck, BsCheckAll } from "react-icons/bs";
// import { io } from "socket.io-client";
// import moment from "moment";
// import axios from 'axios';
// import { deleteMessage as deleteMessageAction } from '../redux/messageSlice';
// import { BASE_URL } from '../config';

// const socket = io("https://chat.onexgames.in", {
//     transports: ['websocket'],
// });

// const Message = ({ message }) => {
//     const scroll = useRef();
//     const [showActionMenu, setShowActionMenu] = useState(false);
//     const { authUser, selectedUser } = useSelector(store => store.user);
//     const dispatch = useDispatch();
//     const messageRef = useRef(null);
//     let longPressTimer = useRef(null);
//     const [copied, setCopied] = useState(false);


//     const isAdmin = authUser?.isRole === 1;

//     // Handle right click (desktop)
//     const handleContextMenu = (e) => {
//         e.preventDefault();
//         setShowActionMenu(true);
//     };

//     // Handle long press (mobile)
//     const handleTouchStart = (e) => {
//         const touch = e.touches[0];
//         const initialX = touch.clientX;
//         const initialY = touch.clientY;
    
//         longPressTimer.current = setTimeout(() => {
//             const currentTouch = e.touches[0];
//             if (
//                 Math.abs(currentTouch.clientX - initialX) < 10 && 
//                 Math.abs(currentTouch.clientY - initialY) < 10
//             ) {
//                 setShowActionMenu(true);
//             }
//         }, 800);
//     };

//     // Handle delete actions (admin only)
//     const handleDelete = async (deleteType) => {
//         try {
//             await axios.delete(`${BASE_URL}/api/v1/message/delete/${message._id}`, {
//                 data: { deleteType },
//                 withCredentials: true
//             });
//             dispatch(deleteMessageAction(message._id));
//             setShowActionMenu(false);
//         } catch (error) {
//             console.error("Delete failed:", error);
//         }
//     };

//     // Handle copy message (for everyone)
//     const handleCopy = () => {
//         if (message?.message) {
//             navigator.clipboard.writeText(message.message);
//             // setShowActionMenu(false);
//               setCopied(true);
//         setTimeout(() => {
//             setCopied(false);
//             setShowActionMenu(false); // Close menu after feedback
//         }, 1000);
            
//             // Show temporary feedback that message was copied
//             // const feedback = document.createElement('div');
//             // feedback.textContent = 'Copied to clipboard';
//             // feedback.style.position = 'fixed';
//             // feedback.style.bottom = '20px';
//             // feedback.style.left = '50%';
//             // feedback.style.transform = 'translateX(-50%)';
//             // feedback.style.backgroundColor = 'rgba(0,0,0,0.7)';
//             // feedback.style.color = 'white';
//             // feedback.style.padding = '8px 16px';
//             // feedback.style.borderRadius = '20px';
//             // feedback.style.zIndex = '1000';
//             // document.body.appendChild(feedback);
            
//             // setTimeout(() => {
//             //     document.body.removeChild(feedback);
//             // }, 1500);
//         }
//     };


//     // Close menu handlers
//     const handleCancel = () => setShowActionMenu(false);

//     // Close menu when clicking outside
//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (messageRef.current && !messageRef.current.contains(e.target)) {
//                 setShowActionMenu(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//             clearTimeout(longPressTimer.current);
//         };
//     }, []);

//     useEffect(() => {
//         if (scroll.current) {
//             scroll.current.scrollIntoView({ behavior: "smooth" });
//         }

//         if (message?.status === "sent" && message?.receiverId === authUser?._id) {
//             socket.emit("messageDelivered", message._id);
//         }
//     }, [message]);

//     // Close menu when clicking outside (updated version)
// useEffect(() => {
//     const handleClickOutside = (e) => {
//         if (showActionMenu && (!messageRef.current?.contains(e.target) || 
//             e.target.classList.contains('fixed'))) {
//             setShowActionMenu(false);
//         }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     document.addEventListener('touchstart', handleClickOutside);
    
//     return () => {
//         document.removeEventListener('mousedown', handleClickOutside);
//         document.removeEventListener('touchstart', handleClickOutside);
//         clearTimeout(longPressTimer.current);
//     };
// }, [showActionMenu]);

//     const imageUrl = message?.imageUrl;
//     const videoUrl = message?.videoUrl;
//     const [mediaError, setMediaError] = useState(false);
//     const isAdminToAdmin = authUser?.isRole === 1 && 
//         message?.senderId !== selectedUser?._id && 
//         message?.senderId !== authUser?._id;

//     return (
//         <div 
//             ref={messageRef}
//             onContextMenu={handleContextMenu}
//             onTouchStart={handleTouchStart}
//             onTouchEnd={() => {
//                 clearTimeout(longPressTimer.current);
//             }}
//             onTouchCancel={() => {
//                 clearTimeout(longPressTimer.current);
//             }}
//             onTouchMove={() => {
//                 clearTimeout(longPressTimer.current);
//             }}
//             className="relative"
//         >
//             <div ref={scroll} className={`chat ${message?.senderId === authUser?._id ? 'chat-end' : 'chat-start'} border-rounded bg-[#efeae2]`}>
//                 <div className="chat-image avatar">
//                     <div className="w-10 rounded-full">
//                         {/* Profile image would go here */}
//                     </div>
//                 </div>
//                 <div className="chat-header">
//                     <time className="text-[10px] opacity-50 text-black">
//                         {moment(message?.createdAt).format("hh:mm A")}
//                     </time>
//                 </div>

//                 {imageUrl ? (
//                     <div className={`chat-bubble ${isAdminToAdmin ? 'bg-blue-100 text-black' : message?.senderId !== authUser?._id ? 'bg-[#fff]' : 'bg-[#d9fdd3]'} p-0 overflow-hidden`}>
//                         <a
//                             href={imageUrl}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="block"
//                         >
//                             {mediaError ? (
//                                 <div className="bg-gray-200 p-4 text-center">
//                                     Couldn't load image
//                                 </div>
//                             ) : (
//                                 <img
//                                     src={imageUrl}
//                                     alt="Chat content"
//                                     className="max-w-xs max-h-60 object-contain cursor-pointer"
//                                     onError={(e) => {
//                                         setMediaError(true);
//                                         e.target.onerror = null;
//                                     }}
//                                 />
//                             )}
//                         </a>
//                     </div>
//                 ) : videoUrl ? (
//                     <div className={`chat-bubble ${isAdminToAdmin ? 'bg-blue-100 text-black' : message?.senderId !== authUser?._id ? 'bg-[#fff]' : 'bg-[#d9fdd3]'} p-0 overflow-hidden`}>
//                         <a
//                             href={videoUrl}
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="block"
//                         >
//                             {mediaError ? (
//                                 <div className="bg-gray-200 p-4 text-center">
//                                     Couldn't load video
//                                 </div>
//                             ) : (
//                                 <video
//                                     controls
//                                     className="max-w-xs max-h-60 cursor-pointer"
//                                     onError={(e) => {
//                                         setMediaError(true);
//                                         e.target.onerror = null;
//                                     }}
//                                 >
//                                     <source src={videoUrl} type="video/mp4" />
//                                     Your browser does not support the video tag.
//                                 </video>
//                             )}
//                         </a>
//                     </div>
//                 ) : (
//                     <div className={`chat-bubble ${isAdminToAdmin ? 'bg-blue-100 text-black' : message?.senderId !== authUser?._id ? 'bg-[#fff] text-black' : 'bg-[#d9fdd3] text-black'}`}
//                         style={{
//                             whiteSpace: 'pre-wrap',
//                             wordBreak: 'break-word',
//                             maxWidth: '300px'
//                         }}
//                     >
//                         {message?.message}
//                     </div>
//                 )}
//                 {message?.senderId === authUser?._id && (
//                     <div className="text-xs text-gray-400 flex items-center">
//                         {message?.status === "sent" && <BsCheck size={18} />}
//                         {message?.status === "delivered" && <BsCheckAll size={18} />}
//                         {message?.status === "seen" && <BsCheckAll size={18} className="text-blue-500" />}
//                     </div>
//                 )}
//                 {message.replied && (
//                     <div className="text-xs text-green-600 mt-1 flex items-center gap-1">
//                         <BsCheckAll size={18} className="text-green-600" />
//                         Replied by {message.repliedBy?.username || "Admin"}
//                     </div>
//                 )}
//             </div>
            
//             {/* WhatsApp-style Action Menu (Copy/Delete) */}
//             {showActionMenu && (
//                 <div className="fixed inset-0 bg-black/30 flex items-end md:items-center justify-center z-50"
//                  onClick={(e) => e.target.classList.contains('fixed') && setShowActionMenu(false)}
//                 >
//                     <div className="bg-white rounded-t-xl md:rounded-xl w-full md:max-w-xs shadow-xl">
//                         <div className="p-2 space-y-2">
//                             {/* COPY OPTION (ALWAYS VISIBLE) */}
//                             <button
//                                 onClick={handleCopy}
//                                 className="w-full text-left p-3 text-green-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
//                             >
//                                 {/* Copy */}
//                                     {copied ? "Copied!" : "Copy"}

//                             </button>

//                             {/* DELETE OPTION (ONLY FOR ADMINS) */}
//                             {isAdmin && (
//                                 <button
//                                     onClick={() => setShowActionMenu('delete')}
//                                     className="w-full text-left p-3 text-green-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
//                                 >
//                                     Delete
//                                 </button>
//                             )}

//                             <button
//                                 onClick={handleCancel}
//                                 className="w-full text-left p-3 text-gray-800 hover:bg-gray-100 rounded-lg text-sm font-medium"
//                             >
//                                 Cancel
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* DELETE CONFIRMATION (ONLY FOR ADMINS) */}
//             {showActionMenu === 'delete' && isAdmin && (
//                 <div className="fixed inset-0 bg-black/30 flex items-end md:items-center justify-center z-50"
//                   onClick={(e) => e.target.classList.contains('fixed') && setShowActionMenu(false)}
//                 >
//                     <div className="bg-white rounded-t-xl md:rounded-xl w-full md:max-w-xs shadow-xl">
//                         <div className="p-4">
//                             <p className="text-gray-800 font-medium mb-4">Delete message?</p>
//                             <div className="space-y-3">
//                                 <button
//                                     onClick={() => handleDelete('forEveryone')}
//                                     className="w-full text-left p-3 text-red-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
//                                 >
//                                     Delete for everyone
//                                 </button>
//                                 <button
//                                     onClick={() => handleDelete('forMe')}
//                                     className="w-full text-left p-3 text-red-600 hover:bg-gray-100 rounded-lg text-sm font-medium"
//                                 >
//                                     Delete for me
//                                 </button>
//                                 <button
//                                     onClick={handleCancel}
//                                     className="w-full text-left p-3 text-gray-800 hover:bg-gray-100 rounded-lg text-sm font-medium"
//                                 >
//                                     Cancel
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Message; 

